module.exports = __webpack_public_path__ + "img/logo-linus-ventures.a220607f.png";